<template>
    <div class="rootPage">
        <!-- 头部 -->
    
        <!-- 侧边栏 -->

        <div class="content">
    
            <router-view ></router-view>
           
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            menu: []
        }
    },
    components: {
    
    },
    created() {
        const width=document.body.clientWidth
        const height=document.body.clientHeight
        this.$store.commit('setWidth',width)
        this.$store.commit('setHeight',height)
            
    },
    mounted() {
        // console.log(menu);
    },
    methods: {
    }
}
</script>

<style lang='scss' scoped>
.rootPage {
    background: rgb(13,27,53);
    width: 100%;
    height: 100%;
    .content {
        box-sizing: border-box;
    }
    //版权
    .copyRight {
        padding-top: 30px;
        padding-bottom: 20px;
    }
}
</style>